<template>
  <div>
    <Head title="Work Order" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/work-orders/issuances">
        Work Orders
      </Link>
      <span class="text-orange-400 font-medium">/</span>{{ workOrder.WO_number }}/{{ workOrder.issuance_team }}
    </h1>
    <div 
      v-show="workOrder.status == 1"
      class="max-w-full bg-white rounded-md shadow overflow-hidden mb-3"
    >
      <form @submit.prevent="store">
        <div class="pb-2 pr-6 w-full lg:w-full mb-8">
          <div class="flex flex-wrap -mb-16 -mr-6 p-8">
            <div class="pb-2 pr-6 w-full lg:w-12/12">
              <text-input
                class="w-full lg:w-full"
                v-model="form.item_id"
                :error="form.errors.item_id"
                placeholder="Scan UID"
              />
            </div>
          </div>
        </div>
        <div
          class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100"
        >
          <loading-button :loading="form.processing" class="btn-orange" type="submit">
            Add Issuance
          </loading-button>
        </div>
      </form>
    </div>
    <hr/>
    <ul class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4" id="tabs-tabFill"
      role="tablist">
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-homeFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active
        " id="tabs-home-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-homeFill" role="tab"
          aria-controls="tabs-homeFill" aria-selected="true">Scans</a>
      </li>
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-summaryFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
        " id="tabs-summary-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-summaryFill" role="tab"
          aria-controls="tabs-summaryFill" aria-selected="false">Summaries</a>
      </li>
    </ul>
    <div class="tab-content" id="tabs-tabContentFill">
      <div class="tab-pane fade show active" id="tabs-homeFill" role="tabpanel" aria-labelledby="tabs-home-tabFill">
        <div class="flex items-center justify-between mb-6">
          <a
            v-if="issuances.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/work-orders/${workOrder.id}/issuances/sub-assemblies/scans/download`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Date</th>
              <th class="pb-3 pt-3 px-3">Item UID</th>
              <th class="pb-3 pt-3 px-3">Part Number</th>
              <th class="pb-3 pt-3 px-3">Description</th>
              <th class="pb-3 pt-3 px-3 text-center">Quantity</th>
              <th class="pb-3 pt-3 px-3">UoM</th>
              <th class="pb-3 pt-3 px-3">Production Line</th>
              <th class="pb-3 pt-3 px-3">Bom</th>
              <th class="pb-3 pt-3 px-3">Issued By</th>
            </tr>
            <tr v-for="item in issuances.data" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-orange-500">
                  {{ item.date }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.item_uid }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.part_no }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.description }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2 text-center" tabindex="-1">
                  {{ item.quantity }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.measure }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.production_line }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.bom }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.user }}
                </span>
              </td>
            </tr>
            <tr v-if="issuances.data.length === 0">
              <td class="px-6 py-4 border-t" colspan="10">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="issuances.links" />
      </div>
      <div class="tab-pane fade" id="tabs-summaryFill" role="tabpanel" aria-labelledby="tabs-summary-tabFill">
          <div class="flex items-center justify-between mb-6">
            <a
              v-if="issuace_summaries.data.length > 0"
              class="btn-orange px-3 py-2 text-xs cursor-pointer"
              :href="`/work-orders/${workOrder.id}/issuances/sub-assemblies/summaries/download`"
              download
              target="__blank"
            >
              <span>Download</span>
            </a>
          </div>
          <div class="bg-white rounded-md shadow overflow-x-auto">
            <div class="px-2 py-2 mb-3 mt-3">
              <h1 class="mb-2 text-1xl">
                <strong>WO NUMBER : </strong> {{ workOrder.WO_number }}
              </h1>
              <h1 v-if="workOrder.issuance_team !== 'mattress finishing'" class="mb-2 text-1xl">
                <strong>PRODUCT : </strong> {{ workOrder.part_description }}
              </h1>
              <h1 class="mb-2 text-1xl">
                <strong>QUANTITY : </strong>{{ workOrder.quantity }}
              </h1>
            </div>
            <table class="w-full whitespace-nowrap">
              <tr class="text-left font-bold">
                <th class="pb-2 pt-2 px-3">Part Number</th>
                <th class="pb-2 pt-2 px-3">Part Description</th>
                <th class="pb-2 pt-2 px-3">BOM per Unit Product</th>
                <th class="pb-2 pt-2 px-3">Quantity Required</th>
                <th class="pb-2 pt-2 px-3">Quantity Issued</th>
                <th class="pb-2 pt-2 px-3">UoM</th>
              </tr>
              <tr
                v-for="inventory in issuace_summaries.data"
                :key="inventory.id"
                class="hover:bg-orange-100 focus-within:bg-gray-100"
              >
                <td class="border-t">
                  <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                    {{ inventory.sku_name }}
                  </span>
                </td>
                <td class="border-t">
                  <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                    {{ inventory.description }}
                  </span>
                </td>
                <td class="border-t">
                  <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                    {{ inventory.bom_per_unit_product }}
                  </span>
                </td>
                <td class="w-px border-t">
                  <span class="flex items-center px-3 py-2 focus:text-indigo-500 text-right">
                    {{ inventory.quantity_required }}
                  </span>
                </td>
                <td class="w-px border-t">
                  <span class="flex items-center px-3 py-2 focus:text-indigo-500 text-right">
                    {{ inventory.quantity_issued }}
                  </span>
                </td>
                <td class="w-px border-t">
                  <span class="flex items-center px-3 py-2 focus:text-indigo-500 text-right">
                    {{ inventory.unit_of_measure }}
                  </span>
                </td>
              </tr>
              <tr v-if="issuace_summaries.data.length === 0">
                <td class="px-6 py-4 border-t" colspan="8">No data found</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Pagination from '@/Shared/Pagination'
import DateRange from '@/Shared/DateRange'

export default {
  components: {
    Head,
    Icon,
    Link,
    DateRange,
    TextInput,
    SelectInput,
    LoadingButton,
    Pagination,
  },
  layout: Layout,
  remember: 'form',
  props: {
    filters: Object,
    workOrder: Object,
    issuances: Object,
    issuace_summaries: Object,
    issuance_team: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        item_id: null,
        issuance_team: this.workOrder.team,
      }),
      search: {
        dateValue: this.filters.dateValue
      },
    }
  },
  computed: {
    role() {
      return this.$inertia.page.props.auth.user.role
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/work-orders/${this.workOrder.id}/issuances/create`, pickBy(this.search), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    store() {
      this.form.post(`/work-orders/${this.workOrder.id}/issuances/store`, {
        onSuccess: () => {
          this.form.reset(
            'item_id',
          )
        }
      })
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>